import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useResetUserIdentification = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => api.identifications.resetIdentification(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
    },
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при сбросе идентификации',
        description: err.response?.data?.message || err.message,
      })
    },
  })
}
